import { NativeConfDto } from '../../dto/NativeDTOs';
import { NativeResultDTO } from '../../dto/NativeResultDTO';
import {
  leonJsCBTable,
  JSCALLNO_EXIT,
  JSCALLNO_READY,
  NativeCallGateway,
  PreDefinedCBID,
} from './NativeJSCallGateway';

const promiseIdMap = new Map();

class NativeCommImpl {
  call<D>(method: string, params: any[]): Promise<NativeResultDTO<D>> {
    return new Promise(function (resolve, reject) {
      if (NativeCallGateway) {
        var id = null;
        var cnt = 0;
        while (null === id && cnt++ < 5) {
          id = Math.floor(Math.random() * 10000000000) + PreDefinedCBID;
          //if(callbackTable.get(id)) {
          if (leonJsCBTable.isRegisteredCb(id)) {
            id = null;
          }
        }
        if (null === id) {
          reject({ result: -1, data: null });
        } else {
          var rpc = { jsonrpc: '2.0', method: method, params: params, id: id };
          NativeCallGateway.postMessage(JSON.stringify(rpc));
          //callbackTable.set(id, function(result:string){
          leonJsCBTable.registerCb(
            id,
            function (result: string) {
              resolve(JSON.parse(result) as NativeResultDTO<D>);
            },
            true,
          );
        }
      } else {
        reject({ result: -1, data: null });
      }
    });
  }

  beginStream<D>(
    method: string,
    params: any[],
    handler: (data: D) => void,
  ): Promise<NativeResultDTO<D>> {
    var id: any = null;
    if (NativeCallGateway) {
      var cnt = 0;
      while (null === id && cnt++ < 5) {
        id = Math.floor(Math.random() * 10000000000) + PreDefinedCBID;
        if (leonJsCBTable.isRegisteredCb(id)) {
          id = null;
        }
      }
    }
    const rpcId = id;
    const promise: Promise<NativeResultDTO<D>> = new Promise(function (
      resolve: any,
      reject,
    ) {
      if (null === rpcId) {
        reject({ result: -1, data: null });
      } else {
        var rpc = { jsonrpc: '2.0', method: method, params: params, id: id };
        NativeCallGateway.postMessage(JSON.stringify(rpc));
        var rpcCb = (result: string) => {
          var resultDto = JSON.parse(
            result.replaceAll('\n', ''),
          ) as NativeResultDTO<D>;
          if (null != resolve) {
            resolve(resultDto);
            resolve = null;
          } else if (null != handler && null != resultDto) {
            return handler(resultDto.data);
          }
          return '';
        };
        leonJsCBTable.registerCb(id, rpcCb, false);
      }
    });
    if (null != rpcId) {
      promiseIdMap.set(promise, rpcId);
    }
    return promise;
  }

  endStream<D>(method: string, beginPromise: any): Promise<NativeResultDTO<D>> {
    return new Promise(function (resolve, reject) {
      var beginId = promiseIdMap.get(beginPromise);
      if (null === beginId) {
        reject({ result: -1, data: null });
      }
      if (NativeCallGateway) {
        var id = null;
        var cnt = 0;
        while (null === id && cnt++ < 5) {
          id = Math.floor(Math.random() * 10000000000) + PreDefinedCBID;
          if (leonJsCBTable.isRegisteredCb(id)) {
            id = null;
          }
        }
        if (null === id) {
          reject({ result: -1, data: null });
        } else {
          var rpc = {
            jsonrpc: '2.0',
            method: method,
            params: [beginId],
            id: id,
          };
          NativeCallGateway.postMessage(JSON.stringify(rpc));
          leonJsCBTable.registerCb(
            id,
            function (result: string) {
              resolve(JSON.parse(result) as NativeResultDTO<D>);
            },
            true,
          );
          promiseIdMap.delete(beginPromise);
        }
      } else {
        reject({ result: -1, data: null });
      }
    });
  }

  onReady(cb: (conf: NativeConfDto) => boolean): boolean {
    if (!NativeCallGateway) {
      return false;
    }
    //callbackTable.set(JSCALLNO_READY, function(confMsg:string){
    leonJsCBTable.registerCb(
      JSCALLNO_READY,
      function (confMsg: string) {
        return cb(JSON.parse(confMsg) as NativeConfDto);
      },
      true,
    );
    return true;
  }

  onExit(cb: (conf: NativeConfDto) => boolean): boolean {
    if (!NativeCallGateway) {
      return false;
    }
    leonJsCBTable.registerCb(
      JSCALLNO_EXIT,
      function (confMsg: string) {
        return cb(JSON.parse(confMsg) as NativeConfDto);
      },
      true,
    );
    return true;
  }
}

export const NativeComm = NativeCommImpl;
